import { AxiosRequestConfig } from 'axios';
import { BASE_API, BaseForExerciseCRUD } from '../utils';

interface UpdateExercise extends BaseForExerciseCRUD
{
  id: string;
}

interface UpdateConfig extends AxiosRequestConfig {
  body: UpdateExercise;
  data: UpdateExercise;
  method: 'PUT';
  url: `/exercises/${string}`;
}

/**
 * PUT /v1/exercises/{id}
 */
export const update = (id: string, data: BaseForExerciseCRUD): UpdateConfig => {
  const payload = {...data, id} as UpdateExercise;
  return {
    baseURL: BASE_API,
    method: 'PUT',
    url: `/exercises/${id}`,
    body: payload,
    data: payload,
  } as const;
};
